export default function getCustomerAccountsData(currentUserAccounts) {
  let customerAccountsData = {};
  currentUserAccounts.forEach((account) => {
    customerAccountsData[account.account_id] = {
      accountCustomerCode: account.account_code,
      accountCountryCode: account.country,
      accountName: account.account_name,
      accountId: account.account_id,
      accountEntityid: account.entity_id,
      accountFatherAccount: account.father_account,
    };
  });
  return customerAccountsData;
}
